import 'whatwg-fetch';
import 'url-search-params-polyfill';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { setOptions, overrideComponent } from '@sheerid/jslib';
import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';
import { captainsCircleNumberValidator } from './lib/Validators/customFieldValidators';
import { StepActiveMilitaryPersonalInfoComponent } from './components/Steps/StepActiveMilitaryPersonalInfoComponent';
import { StepInactiveMilitaryPersonalInfoComponent } from './components/Steps/StepInactiveMilitaryPersonalInfoComponent';
import { StepCollectMilitaryStatusComponent } from './components/Steps/StepCollectMilitaryStatusComponent';
import { StepSuccessComponent } from './components/Steps/StepSuccessComponent';
import { StepDocUploadComponent } from './components/Steps/StepDocUploadComponent';
import { StepPendingComponent } from './components/Steps/StepPendingComponent';
import { StepErrorComponent } from './components/Steps/StepErrorComponent';

setOptions(defaultOptions);
googleTagManagerHook();
captainsCircleNumberValidator();

// @ts-ignore
overrideComponent('StepActiveMilitaryPersonalInfoComponent', StepActiveMilitaryPersonalInfoComponent);
// @ts-ignore
overrideComponent('StepInactiveMilitaryPersonalInfoComponent', StepInactiveMilitaryPersonalInfoComponent);
overrideComponent('StepCollectMilitaryStatusComponent', StepCollectMilitaryStatusComponent);
// @ts-ignore
overrideComponent('StepDocUploadComponent', StepDocUploadComponent);
// @ts-ignore
overrideComponent('StepPendingComponent', StepPendingComponent);
overrideComponent('StepSuccessComponent', StepSuccessComponent);
// @ts-ignore
overrideComponent('StepErrorComponent', StepErrorComponent);

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
